import { render, staticRenderFns } from "./BaseMultiSourceSection.vue?vue&type=template&id=dcf20970&scoped=true"
import script from "./BaseMultiSourceSection.vue?vue&type=script&lang=js"
export * from "./BaseMultiSourceSection.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiSourceSection.vue?vue&type=style&index=0&id=dcf20970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf20970",
  null
  
)

export default component.exports